import React from 'react'
import { sparkSegments, currencyFormat } from './arAgingModel'

// 96×8 stacked aging bar. Segment tones are token names → CSS vars.
const TONE_VAR = {
  'line-2': 'var(--line-2)',
  warn: 'var(--warn)',
  accent: 'var(--accent)',
  danger: 'var(--danger)',
  'primary-soft': 'var(--primary-soft)'
}

const ArSparkBar = ({ buckets }) => {
  const segments = sparkSegments(buckets)
  const tooltip = [
    ['1-30', buckets.age30],
    ['31-60', buckets.age60],
    ['61-90', buckets.age90],
    ['90+', buckets.age90Plus]
  ]
    .filter(([, amount]) => amount > 0)
    .map(([label, amount]) => `${label} ${currencyFormat(amount)}`)
    .join(' · ') || 'No past-due balance'

  return (
    <div className="ar-spark" title={tooltip}>
      {segments.map((segment, index) => (
        <span
          key={index}
          className="ar-spark-seg"
          style={{ width: `${segment.pct}%`, background: TONE_VAR[segment.tone] || 'var(--line-2)' }}
        />
      ))}
    </div>
  )
}

export default ArSparkBar
